import styled from 'styled-components';
import { AppStyledProps } from '../../../types';

// eslint-disable-next-line @typescript-eslint/ban-types
type T = {} & AppStyledProps;
export const Wrapper = styled.div<T & { backgroundImage: string }>`
  overflow: hidden;
  font-family: 'Roboto';
  font-size: 16px;
  color: white;
  width: 100vw;
  height: 100vh;
  margin: 0;
  z-index: 999;
  position: absolute;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background: #333;

  ${({ theme }) =>
    theme.device.mobile &&
    `
    font-size: 12px;
    height: calc(var(--vh, 1vh) * 100);
  `}
`;

export const ImageBlock = styled.div<T>`
  background-image: url('/crash.svg');
  background-size: cover;
  height: 12.5em;
  width: 12.5em;
`;

export const TextBlockWrap = styled.div<T>`
  margin: 50px auto 0 auto;
  max-width: 700px;
  text-align: center;
  ${({ theme }) =>
    theme.device.mobile &&
    `
      margin-top: 20px;
      ${!theme.device.landscape && `max-width: 320px;`}
    `}
`;

export const TitleText = styled.div<T>`
  font-weight: 400;
  font-size: 3em;
  line-height: 116.7%;
  text-align: center;
  color: #ffffff;
  margin: 0 auto 30px;
`;

export const DescriptionText = styled.div<T>`
  display: none;
  font-size: 1.25em;
  padding: 0 50px;
  margin-bottom: 30px;
  line-height: 160%;
  letter-spacing: 0.15px;
`;

export const ButtonWrap = styled.div<T>`
  font-size: 1em;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  & > button {
    margin-right: 1.25em;
  }
`;

export const Button = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px 16px;
  min-height: 40px;
  background: rgba(107, 107, 107, 0.01);
  border: 1px solid #ffffff;
  border-radius: 4px;
  color: white;

  & > i {
    margin-right: 0.2em;
  }

  &:hover {
    opacity: 0.7;
  }
`;
